import React, { useEffect, useState, useRef, MutableRefObject } from 'react';

import Grid, { Col } from 'Components/Grid';

import { Container, Heading, Wave } from './CourseListing.styled';

export interface Props {
    heading: string;
}

const CourseListing: React.FC<Props> = props => {
    const { heading } = props;

    const [containerHeight, setContainerHeight] = useState<number>(0);
    const containerRef = useRef() as MutableRefObject<HTMLDivElement>;

    useEffect(() => {
        setContainerHeight(containerRef.current.clientHeight / 16);
    }, [containerHeight]);

    return (
        <Container ref={containerRef}>
            <Wave $containerHeight={containerHeight} />
            <Grid>
                <Col>
                    <Heading>{heading}</Heading>
                </Col>
            </Grid>
        </Container>
    );
};

export default CourseListing;
